
import React from 'react';
import { ScrollArea } from '@/components/ui/scroll-area';
import SurplusTable from './SurplusTable';
import { Recommendations } from './types';

interface RecommendationsPanelProps {
  recommendations: Recommendations;
  filterLabel: string;
}

const RecommendationsPanel: React.FC<RecommendationsPanelProps> = ({ 
  recommendations, 
  filterLabel 
}) => {
  return (
    <div className="w-[20%] bg-secondary/80 p-4 border border-primary/20 transition-all duration-500 hover:border-primary/40 shadow-lg rounded-sm px-[20px] my-0 py-[5px] h-[calc(97vh-280px)]">
      <h3 className="text-primary-light font-medium mb-2 my-0">
        Recommendations {filterLabel}
      </h3>
      <ScrollArea className="h-[calc(100%-30px)] pr-2">
        <div className="space-y-4 mt-3 my-0">
          <SurplusTable 
            items={recommendations.highestSurplus}
            totalValue={recommendations.totalLateStageValue}
            title="1. Top Surplus Late Stage Pipelines of Accounts (achieved >= 100%), Ranked By Value"
            subtitle="surplus"
          />
          
          <SurplusTable 
            items={recommendations.lowestPerforming}
            totalValue={recommendations.lowestPerformingTotalValue}
            title="2. Largest Late Stage Pipelines of the Lowest 25th Percentile of Account Achievements"
            subtitle="low-perf"
          />
        </div>
      </ScrollArea>
    </div>
  );
};

export default RecommendationsPanel;
